import { useEffect, useState } from 'react'
import { GoogleMap, MarkerF } from '@react-google-maps/api'
import { extendBoundsByOffset, MAP_SETTINGS } from 'utils'
import markerIcon from 'assets/images/team-locations-marker.png'
import mapStyles from './mapStyles.json'

export interface IMapContainerProps {
  coordinates: { lat: number; lng: number }

  onClick?: () => void
}

const { DEFAULT_ZOOM, DEFAULT_CENTER, DEFAULT_MAP_OPTIONS } = MAP_SETTINGS

const MapContainer = ({ coordinates, onClick }: IMapContainerProps) => {
  const [mapRef, setMapRef] = useState<google.maps.Map | null>(null)

  useEffect(() => {
    //@ts-ignore
    const bounds = new window.google.maps.LatLngBounds()
    if (coordinates) {
      bounds.extend(
        //@ts-ignore
        new window.google.maps.LatLng(coordinates.lat, coordinates.lng)
      )

      extendBoundsByOffset(bounds, 1.5)

      //@ts-ignore
      mapRef?.fitBounds(bounds)
    }
  }, [coordinates])

  return (
    <GoogleMap
      zoom={DEFAULT_ZOOM}
      center={DEFAULT_CENTER}
      options={{ ...DEFAULT_MAP_OPTIONS, styles: mapStyles }}
      mapContainerStyle={{
        height: '100%',
        width: '100%',
      }}
      onLoad={(map) => setMapRef(map)}
      onClick={onClick}
    >
      {coordinates && (
        <MarkerF
          position={coordinates}
          icon={{
            url: markerIcon,
            //@ts-ignore
            scaledSize: new window.google.maps.Size(25.5, 32.58),
          }}
        />
      )}
    </GoogleMap>
  )
}

export default MapContainer
